import React, { FocusEvent, useCallback } from "react";
import { Modal, Form } from "react-bootstrap";
import { useForm } from "react-hook-form";

import { ErrorMessage, Button } from "components";
import CloseButton from "components/closeButton";
import { maxLength1000 } from "validators/validation";

import styles from "./modal.module.scss";

type AddCommentModalProps = {
	show: boolean;
	onHide: () => void;
	title: string;
	onSubmit: Function;
	comments?: string;
};

const AddCommentModal = ({
	show = false,
	onHide,
	title = "Add Notes",
	onSubmit,
	comments,
}: AddCommentModalProps) => {
	const {
		register,
		handleSubmit,
		formState: { errors, isDirty },
	} = useForm({
		mode: "onSubmit",
		defaultValues: {
			comments,
		},
	});

	const handleBlur = useCallback((e: FocusEvent<HTMLTextAreaElement>) => {
		if (e.target.value) {
			e.target.value = e.target.value.trim();
		}
	}, []);

	const handleSubmitForm = form => {
		onHide();
		onSubmit(form);
	};

	return (
		<Modal
			show={show}
			onHide={onHide}
			animation={false}
			centered
			className={styles.wrappRejectWithReasonModal}
		>
			<Modal.Header className="pb-0">
				<Modal.Title as="h6" className="text-center mb-3">
					{title}
				</Modal.Title>
				<CloseButton onClick={onHide} />
			</Modal.Header>
			<Modal.Body>
				<form onSubmit={handleSubmit(handleSubmitForm)}>
					<div className={styles.content}>
						<Form.Control
							as="textarea"
							{...register("comments", {
								validate: {
									maxLength1000,
								},
							})}
							onBlur={handleBlur}
							id="comments"
							placeholder="Enter Comments"
							rows={5}
						/>
						<ErrorMessage field="comments" errors={errors} />
					</div>
					<div className={`${styles.wrappButtonsCenter} pb-5 pt-5`}>
						<Button
							type="submit"
							value="Save"
							variant="primary"
							disabled={!isDirty}
						/>
					</div>
				</form>
			</Modal.Body>
		</Modal>
	);
};

export default AddCommentModal;
